export default __webpack_public_path__ + "static/saas-and-crm-3cc4cd940df2867f28241659f5283149.png";